import { createAsyncThunk } from "@reduxjs/toolkit";
import { setError, setNotification, setSuccess } from "../reducers/common";

export const asyncAlertError = createAsyncThunk(
  "error",
  async (msg, { dispatch }) => {
    dispatch(setError(msg));
    setTimeout(() => {
      dispatch(setError(null));
    }, 3000);
  }
);

export const asyncAlertSuccess = createAsyncThunk(
  "success",
  async (msg, { dispatch }) => {
    dispatch(setSuccess(msg));
    setTimeout(() => {
      dispatch(setSuccess(null));
    }, 3000);
  }
);

export const asyncAlertNotification = createAsyncThunk(
  "notification",
  async (payload, { dispatch }) => {
    dispatch(setNotification(payload));
  }
);
